import React, { PropsWithChildren } from 'react'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'

export type AccountAccessSurface = 'modal' | 'page'

interface Props {
  title?: string;
  onBackButtonClick?: () => void;
  dismissible?: boolean;
}

function AccountAccessModalWrapper(props: PropsWithChildren<Props>) {
  const { title = '', onBackButtonClick, dismissible, children } = props

  return <>
    <ModalHeader
      title={title}
      onBackButtonClick={onBackButtonClick}
      dismissible={dismissible}
    />
    <ModalBody>
      <ModalContent>
        {children}
      </ModalContent>
    </ModalBody>
  </>
}

export default AccountAccessModalWrapper
